export default function managerAssistantSettings(state = [], action) {
  switch (action.type) {
    case 'MANAGER_ASSISTANT_SETTING_PUT_RESPONSE':
      return state.map(manager_assistant_setting => {
        if (manager_assistant_setting.id === action.payload.id)
          return { ...manager_assistant_setting, ...action.payload };
        return manager_assistant_setting;
      });
    case 'MANAGER_ASSISTANT_SETTINGS_GET_RESPONSE':
      return action.payload;
    default:
      return state;
  }
}
